module.exports = __webpack_public_path__ + "static/media/logo-white.040452f3.svg";